import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import LoadingIndicator from "components/LoadingIndicator/LoadingIndicator";

import MarketManagement from "components/Market/Management/Management";

import * as marketReducer from "containers/Market/MarketReducer";
import * as nextModelsReducer from "containers/Next/Models/ModelsReducer";

class MarketManagementContainer extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const {} = this.props;

    return <MarketManagement {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    updateHireJob: (jobId, isHire) => dispatch(marketReducer.updateHireJob(jobId, isHire)),
    updateIsCreateJob: (isCreateJob) => dispatch(marketReducer.updateIsCreateJob(isCreateJob)),
    deleteJob: (jobId) => dispatch(marketReducer.deleteJob(jobId)),
    updateIsReviewingJob: (isReviewing) => dispatch(marketReducer.updateIsReviewingJob(isReviewing)),

    viewAndStartReplay: (nextId, user) => dispatch(nextModelsReducer.viewAndStartReplay(nextId, user))
  };
};

const mapStateToProps = (state, ownProps) => {
  return {
    jobs: marketReducer.getJobsArr(state)
  };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(MarketManagementContainer);
